<template>
<div id="page-carga_adjuntos_aa" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar Adjuntos a Expediente" class="elevation-1 px-5 py-3" >
                   
                    <v-card-actions>
                        <v-spacer></v-spacer>                        
                            <exportar-excel :data="camposFacturaLayout" :exportFields="encabezadoFacturaLayout" name="Layout Facturas Pedimento.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Layout Facturas Pedimento" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>                        
                    </v-card-actions>
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <p class="text-justify" >
                                            <v-icon color="indigo" >info</v-icon>                                            
                                            <strong>El archivo ZIP debe ser nombrado de la siguiente manera: 
                                                <br/> - Para pedimentos utilizar el formato: Aduana-Patente-Pedimento-AñoPedimento.zip (ej. 240-1234-9000005-2019.zip)
                                                <br/>Los nombres de los archivos dentro del ZIP no deben contener acentos ni caracteres especiales 
                                                    y deben tener un tipo de documento válido al inicio (Ver <v-btn small outlined text @click="showApendice()" >Apéndice de Tipos de Documentos</v-btn>, ej. 170_Factura123.xml)</strong>
                                        </p>

                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn@click.native="modal=false; reset();" >
                                <v-icon>cancel</v-icon> Cancelar</v-btn>
                                <v-btn v-if="false" color="success" >
                                    <v-icon>done</v-icon>Guardar
                                </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

        <!-- MODAL Apendice-25-Tipos de Documentos -->
        <v-dialog v-model="modalApendice" max-width="80%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modalApendice = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Tipos de Documentos</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <v-client-table ref="vuetableApendice" :data="apendice_items" :columns="columns" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>                                                                        
                    </v-client-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modalApendice = false" >
                        <v-icon>cancel</v-icon>Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'

export default {
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        //this.model.cliente = 52;    
    },
    data() {
        return {
            fab: false,

            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Cargar Adjuntos Pedimento",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],
            columns: [
                "clave",
                "descripcion", 
                "recibe_facturas",
                "recibe_layouts",           
            ],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",
            
            encabezadoFacturaLayout: {
                tax_id:"tax_id",	
                fecha:"fecha",
                numero:"numero",	
                secuencia:"secuencia",
                concepto:"concepto",
                descripcion:"descripcion",
                cantidad:"cantidad",
                um:"um",
                valor_unitario:"valor_unitario",
                subtotal:"subtotal",
                total_facturado:"total_facturado",	
                clave_moneda:"clave_moneda",
            },
            //van vacíos para solo descargar layout con encabezados
            camposFacturaLayout: [{
                tax_id:"[RFC o Tax ID del emisor]",	
                fecha:"[Fecha de Expedición en formato AAAA-MM-DD]",
                numero:"[Número de Factura]",	
                secuencia:"[Número de Partida secuencia de Factura]",
                concepto:"[Seguros | Fletes | Maniobras | Otros]",
                descripcion:"[Descripción del incrementable]",
                cantidad:"[Cantidad]",
                um:"[Unidad de Medida]",
                valor_unitario:"[Valor en USD o MXN]",
                subtotal:"[Valor en USD o MXN]",
                total_facturado:"[Valor en USD o MXN]",	
                clave_moneda:"[Clave USD o MXN]",
            }]

        };
    },

    methods: {
      
        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                const files = e.target.files;
                
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                                        
                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                    var valido = false;

                    if (nombre.length == 2){                        
                        split = nombre[0].split("-");
                        if (split.length == 4){
                            const patternPedimento = /^[0-9]+-{1}[0-9]+-{1}[0-9]+-{1}[0-9]+$/;
                            if (patternPedimento.test(nombre[0])){                                
                                valido = true;
                            }                            
                        } 
                    } 

                    if (valido == false){
                        this.reset();
                        this.$swal({
                            type: "warning",
                            title: "Favor de verificar",
                            text: "El archivo ZIP debe tener el nombre correcto con número de pedimento y año.",
                            footer: ""
                        });
                    } else {
                        
                        /*Se cambio para que lo suba directo a S3 y ya luego lo lea en la lambda*/
                        this.uploadFile(files[0], nombre[0]);                        

                        /*var thisObj = this;
                        const fr = new FileReader()
                        fr.readAsDataURL(files[0])

                        fr.addEventListener('load', () => {
                            this.file = fr.result; // this is an image file that can be sent to server...          
                            var n = this.file.search("base64,");
                            //Para dejar solo el archivo en base 64 y quitar laparte de "application/zip; base64,"
                            
                            if (n >= 0) {
                                this.file = this.file.substring(n + 7);
                            }
                            //console.log(this.file);
                            this.submitFile(nombre[0]);
                            
                        });*/
                        
                    }                    

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            
            var ped = referencia.split("-");
            var pedimento=ped[0]+"-"+ped[1]+"-"+ped[2];
            var anio=ped[3];
            var valida = {
                pedimento: pedimento, 
                anio: anio,
                "id_grupo": parseInt(this.$local_storage.get("id_grupo")),
            }
            var thisObj = this;
            axios.post(this.$hostname + 'reportes/valida_referencia_pedimento/', valida)
                .then((r)=>{
                    var keyFile = "bandeja_entrada/" + thisObj.name_file ;
                    var rfc_pedimento = r.data;
                    console.log("rfc_pedimento: ", rfc_pedimento);
                    var datos = {
                        key: keyFile,
                        bucket: "production.econnect.ds",
                        type: thisObj.type_file
                    }
                    axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                        .then((res) => {
                            if (typeof res.data !== 'undefined') {                        
                                var urlput = res.data.mensaje;
                                //console.log(urlput);
                                axios.put(urlput, file, {headers:{'Content-Type': thisObj.type_file}})
                                .then((res) => {
                                    thisObj.submitFile(rfc_pedimento+"-"+referencia, keyFile);                            
                                })                            
                                .catch((error)=>{
                                    thisObj.$root.$dialogLoader.hide();
                                    thisObj.$swal({
                                        type: "error",
                                        title: "¡Operación no Permitida!",
                                        text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                        footer: '',
                                    });
                                    console.log(error);
                                });
                                
                            } else {
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                            }
                        })
                        .catch((error) => {
                            var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                mensaje = error.response.data.mensaje;
                            thisObj.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: mensaje,
                                footer: '',
                            });
                            console.log(error);
                            thisObj.$root.$dialogLoader.hide();
                        });
                }).catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No existe o no tiene acceso a pedimento "+pedimento+" del año "+anio+". Favor de verificar.",
                        footer: '',
                    });
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });            

        },

        submitFile(referencia, keyFile) {   
            let formData = {
                key: keyFile,
                filename: this.name_file,
                tipo: 'mercancia',//Por default
                referencia: referencia,
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };
            /*let formData = {
                key: "keystring",
                filename: "730-3658-0003766-2020.zip",
                tipo: 'mercancia',//Por default
                referencia: this.$local_storage.get("rfc") +"-730-3658-0003766-2020",
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };*/
                         
            axios.post(this.$hostname + 'leexml/', formData)                            
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;                                
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {                        
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        showApendice(){
            if (this.apendice_items.length <= 0){            
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                                                
                    axios.post(this.$hostname + 'apendices/lista/', {tabla:25})
                        .then((res) => {
                            this.apendice_items = res.data;
                            for( var k in this.apendice_items){
                                if(this.apendice_items[k].recibe_facturas!=undefined && this.apendice_items[k].recibe_facturas==1)
                                    this.apendice_items[k].recibe_facturas = "Si";
                                else
                                    this.apendice_items[k].recibe_facturas = "No";
                                
                                if(this.apendice_items[k].recibe_layouts!=undefined && this.apendice_items[k].recibe_layouts==1)
                                    this.apendice_items[k].recibe_layouts = "Si";
                                else
                                    this.apendice_items[k].recibe_layouts = "No";
                            }
                            this.modalApendice =true;
                        })
                        .catch((error) => {                        
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al obtener los registros del apéndice",
                                footer: "",
                            });
                            console.log(error);                    
                        }).then(() => {                        
                            this.$root.$dialogLoader.hide();                        
                        });
            } else {
                this.modalApendice =true;
            }
        },
    }
};
</script>
